let apiServer = 'https://app.siteglue.ai:8082';
let webSocketServer = 'wss://app.siteglue.ai:8989?';
if (window.location.href.includes('localhost')) {
    apiServer = 'http://localhost:8082';
    webSocketServer = 'ws://localhost:8989?';
}
export const API_SERVER = apiServer;
export const WEB_SOCKET_SERVER = webSocketServer;
